
export type ThemeTokens = Record<string, string>;

/**
 * Convert theme tokens to CSS variables
 * Converts token keys like "color.primary" to CSS variables like "--color-primary"
 */
export function tokensToCssVariables(tokens: ThemeTokens): string {
  if (!tokens) return '';
  
  return Object.entries(tokens)
    .map(([key, value]) => {
      const cssKey = key.startsWith('--') ? key : `--${key.replace(/\./g, '-')}`;
      // Sanitize value to prevent XSS (basic check)
      const sanitizedValue = String(value)
        .replace(/[<>]/g, '')
        .replace(/javascript:/gi, '')
        .replace(/expression\(/gi, '')
        .trim();
        
      return `${cssKey}: ${sanitizedValue};`;
    })
    .join('\n      ');
}

